import { FormLabel, Input, VisuallyHidden } from "@chakra-ui/react"
import { FieldConfig } from "formik"
import { Fragment, forwardRef } from "react"
import FormField from "./FormField"

export type FieldChildren =
  | React.FC<{ field: React.ReactNode }>
  | null
  | undefined

const Field = forwardRef(function Field<
  TFieldProps extends React.ComponentProps<
    FieldConfig["as"] extends React.ElementType
      ? FieldConfig["as"]
      : typeof Input
  >,
  // TFieldProps extends "as" extends keyof FieldConfig ? {} : InputProps,
  // TFieldProps extends InputProps,
  TName extends string = string
>(
  {
    children,
    ...props
  }: Omit<FieldConfig & TFieldProps, "children"> & {
    name: TName
    label?: string
    hideLabel?: boolean
    children?: FieldChildren
  },
  ref: React.ForwardedRef<HTMLInputElement>
): JSX.Element {
  const field = (
    <FormField.Field
      ref={ref}
      as={Input}
      id={props.name}
      variant="filled"
      {...props}
    />
  )

  const MaybeHideLabel = props.hideLabel ? VisuallyHidden : Fragment

  return (
    <FormField.Provider name={props.name}>
      <FormField.Control>
        {!!props.label && (
          <MaybeHideLabel>
            <FormLabel mb={1} color="blackAlpha.900">
              {props.label}
            </FormLabel>
          </MaybeHideLabel>
        )}
        {children ? children({ field }) : field}
        <FormField.ErrorMessage />
      </FormField.Control>
    </FormField.Provider>
  )
})

export default Field
